import { render, staticRenderFns } from "./ClientTestimonialItem.vue?vue&type=template&id=3fb49caf&scoped=true&"
import script from "./ClientTestimonialItem.vue?vue&type=script&lang=js&"
export * from "./ClientTestimonialItem.vue?vue&type=script&lang=js&"
import style0 from "./ClientTestimonialItem.vue?vue&type=style&index=0&id=3fb49caf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb49caf",
  null
  
)

export default component.exports